































import BaseCard from "../../Base/BaseCard.vue";
import BaseWrapper from "../../Base/BaseWrapper.vue";
import { Vue, Component } from "vue-property-decorator";

@Component({
    components: { BaseWrapper, BaseCard },
})
export default class OthersDashboardProfileAlert extends Vue {
    get me() {
        return this.$store.state.users.me;
    }

    get showAlert() {
        return this.me && !this.me.profile;
    }

    goToProfile() {
        this.$router.push("/app/pengaturan");
    }
}
